// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"20ea8b6b","202":"20ea8b6b","244":"20ea8b6b","407":"20ea8b6b","426":"20ea8b6b","531":"20ea8b6b","691":"20ea8b6b","777":"20ea8b6b"}[chunkId] + ".chunk.css";
};